import cookieModel from './cookie';

export default {
  logout: function (router) {
    cookieModel.deleteCookie('ticketlab_access');
    cookieModel.deleteCookie('ticketlab_access');
    router.push({
      name: 'Login'
    });
  },
  isLoggedIn: function () {
    return !(
      !cookieModel.getCookie("ticketlab_access") ||
      cookieModel.getCookie("ticketlab_access") === ''
    );
  },
};
